/* eslint-disable no-unused-vars */
import React, { useEffect, useMemo } from 'react'
import { useHistory } from 'react-router-dom'
import { useDispatch } from 'react-redux'

import mapboxgl from 'mapbox-gl'
import { createStoreMarker } from './createMarker'

import { cliqueLoja } from '~/track'
import actions from '~/actions'

function getCord(s) {
  return s.coordinates.latlon.split(',').reverse().map(parseFloat)
}

function MapStoresPoints({
  stores,
  segmentation,
  user,
  mapRef: { current },
  currentStore,
  storeHover,
  setStoreHover,
  isMobile,
  pin,
  config,
  currentProduct,
}) {
  const history = useHistory()
  const dispatch = useDispatch()

  function onSelectStore(store) {
    cliqueLoja(config, store, currentProduct, user, 'mapa')
    dispatch(actions.selectStore(store))
    history.push(`/loja/${window.btoa(store.cnpj)}`)
  }

  useEffect(() => {
    const markers = []

    function insertStores() {
      const userLngLat = [user.lng || 0, user.lat || 0]
      const bounds = new mapboxgl.LngLatBounds()
      bounds.extend(userLngLat)
      const boundsCount = isMobile ? 2 : 3

      stores.forEach((store, index) => {
        // quando for mobile, faz bounds somente com o user e a loja mais próx
        // se for desktop, faz bounds com user + 2 lojas mais próximas
        const storeLngLat = getCord(store)

        // validate coordinates before using them with mapbox
        if (
          !Array.isArray(storeLngLat) ||
          storeLngLat.length < 2 ||
          !isFinite(storeLngLat[0]) ||
          !isFinite(storeLngLat[1])
        ) {
          // skip stores with invalid coordinates
          console.warn('MapStoresPoints: skipping store with invalid coordinates', store?.cnpj, store?.coordinates)
          return
        }

        if (index < boundsCount) bounds.extend(storeLngLat)

        const marker = createStoreMarker(
          current.map,
          store,
          segmentation,
          onSelectStore,
          () => setStoreHover(index),
          pin,
        )
        if (marker) markers.push(marker)
      })

      current.map.fitBounds(bounds, {
        minZoom: 13,
        maxZoom: 15,
        linear: true,
        padding: isMobile ? 50 : 75,
      })
    }

    function clearStores() {
      markers.forEach((i) => i.remove())
    }

    if (stores) {
      insertStores()
    }

    return clearStores
  }, [stores])

  const storeHoverCnpj = useMemo(() => {
    try {
      return currentStore ? currentStore.cnpj : stores[storeHover].cnpj
    } catch (error) {
      return ''
    }
  }, [stores, storeHover, currentStore])

  if (!storeHoverCnpj) {
    return null
  }

  return (
    <style>
      {`
        div[id*="map-store"] {
          filter: grayscale(0.6);
        }
        #map-store-${storeHoverCnpj} {
          z-index: 100 !important;
          filter: grayscale(0);
        }
        #map-store-${storeHoverCnpj} .map-title{
          opacity: 1;
          transform: translate(-50%, -50%) scale(1);
        }
        #map-store-${storeHoverCnpj} .store-shadow {
          opacity: 1;
          transform: scale(1);
        }
        #map-store-${storeHoverCnpj} .store-pulse:after {
          animation: pulsate 1s ease-out infinite;
          transform: scale(1.4);
        }
        #map-store-${storeHoverCnpj} img, #map-store-${storeHoverCnpj} svg {
          transform: scale(1.4);
        }
      `}
    </style>
  )
}

export default MapStoresPoints
